import { useState } from 'react';
import { assets } from '../assets/assets';
import { FaWhatsapp } from "react-icons/fa6";
import { FaGoogle } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { BiSolidEdit } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import axiosInstance from '../api/axiosInstance';

const OtpLogin = () => {
    const [step, setStep] = useState('phone'); // 'phone' or 'otp'
    const [phone, setPhone] = useState('');
    const [otp, setOtp] = useState('');
    const [timer, setTimer] = useState(30);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const [phoneError, setPhoneError] = useState('');
    const [otpError, setOtpError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();
    
    const handlePhoneSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axiosInstance.post('/send-otp', {
                phone: phone,
            });
            toast.success(response.data.message);
            setPhoneError('');
            setStep('otp');
            
        } catch (err) {
            const msg = err.response?.data?.errors?.phone?.[0] || 'Failed to send OTP';
            setPhoneError(msg);
            // const phoneValidationError = error.response?.data?.errors?.phone?.[0];
            // if (phoneValidationError) {
            //     setPhoneError(phoneValidationError);
            // } else {
            //     const fallback = error.response?.data?.message || 'Failed to send OTP. Please try again.';
            //     setPhoneError(fallback);
            //     toast.error(fallback);
            // }
        } finally {
            setLoading(false);
        }

    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axiosInstance.post('/verify-otp', {
                phone: phone,
                otp: otp
            });

            // localStorage.setItem('authToken', response.data.token);
            login(response.data.token); 
            toast.success(response.data.message);
            setOtp('');
            setStep('phone');
            navigate('/account');

        } catch (err) {
            const msg = err.response?.data?.errors?.otp?.[0] || 'Failed to verify OTP';
            setOtpError(msg);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let interval;

        if (step === 'otp') {
            setIsResendDisabled(true);
            setTimer(30);

            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer <= 1) {
                        clearInterval(interval);
                        setIsResendDisabled(false);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [step]);

    return (
        <div className='login-section'>
            <div className="login_page" style={{ backgroundImage: `url(${assets.sign_up})` }}>
                <div className="p-3 p-xl-5">
                    <div className="login-form mt-5 mx-auto position-relative z-3">
                        <div className="title mb-5 text-center">
                            {step === 'phone' ? 'Login with Phone' : 'Enter OTP'}
                        </div>

                        <form onSubmit={step === 'phone' ? handlePhoneSubmit : handleOtpSubmit} className="mt-5">
                            {step === 'phone' ? (
                                <div className="mb-4">
                                    <input
                                        type="tel"
                                        name="phone"
                                        className={`form-control ${phoneError ? 'is-invalid' : ''}`}
                                        placeholder="Enter phone number"
                                        value={phone}
                                        onChange={(e) => {
                                            setPhone(e.target.value);
                                            setPhoneError('');
                                        }}
                                    />
                                    {phoneError && (
                                        <div className="invalid-feedback d-block">
                                            {phoneError}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <>
                                    <div className="alert alert-info text-center mb-4">
                                        OTP sent to <strong>{phone} </strong>
                                        
                                        <span
                                            type="button"
                                            className="small mt-2"
                                            onClick={() => {
                                                setStep('phone');
                                                setOtp('');
                                            }}
                                        >
                                            <BiSolidEdit style={{ marginRight: '5px', marginLeft: '5px' }} title='Change Phone Number' />
                                        </span>
                                    </div>
                                    <div className="mb-4">
                                        <input
                                            type="number"
                                            name="otp"
                                            className="form-control"
                                            placeholder="Enter OTP"
                                            value={otp}
                                            onChange={(e) => {
                                                setOtp(e.target.value);
                                                setOtpError('');
                                            }}
                                        />
                                        {otpError && (
                                            <div className="invalid-feedback d-block">
                                                {otpError}
                                            </div>
                                        )}
                                    </div>
                                    <div className="mb-4 text-end">
                                        {isResendDisabled ? (
                                            <span className="text-muted">Resend OTP in {timer}s</span>
                                        ) : (
                                            <span
                                                type="button"
                                                className="text-info"
                                                onClick={() => {
                                                    console.log('Resending OTP to:', phone);
                                                    setTimer(30);
                                                    setIsResendDisabled(true);
                                                }}
                                            >
                                                Resend OTP
                                            </span>
                                        )}
                                    </div>
                                </>
                            )}

                            <div className="mb-4">
                                <button type="submit" className="login_btn btn btn-primary w-100" disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            {step === 'phone' ? 'Sending OTP...' : 'Verifying OTP...'}
                                        </>
                                    ) : (
                                        step === 'phone' ? 'Send OTP' : 'Verify OTP'
                                    )}
                                </button>
                            </div>

                            <div className="divider mb-4 d-flex align-items-center justify-content-center">
                                <div className="hr"></div>
                                <span>Or With</span>
                                <div className="hr"></div>
                            </div>

                            <div className="social_login mb-4">
                                <Link className="d-block w-100 btn btn-primary text-center mb-4 position-relative" style={{ backgroundColor: '#F8BC3D' }}>
                                    <FaWhatsapp />
                                    Login with Whatsapp
                                </Link>
                                <Link className="d-block w-100 btn btn-outline-dark text-center mb-4 position-relative">
                                    <FaGoogle />
                                    Login with Google
                                </Link>
                            </div>

                            <div className="create_acc text-center">
                                {
                                    step === 'otp' ? (
                                        <p className="text-primary common-log" onClick={() => setStep('phone')}>
                                            Back to Phone Login
                                        </p>
                                    ) : (
                                        <Link to="/login" className="text-primary common-log">
                                            Use Email Login
                                        </Link>
                                    )
                                }
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default OtpLogin;
